import { Slot } from 'radix-ui'

import { useDeleteAnchorStrategy } from '../../lib/useDeleteAnchorStrategy'

export function DeleteStrategyTrigger({
	children,
	id,
}: {
	children: React.ReactNode
	id: string
}) {
	const { handleDeleteStrategy } = useDeleteAnchorStrategy(close)

	return (
		<Slot.Root onClick={() => handleDeleteStrategy(id)}>{children}</Slot.Root>
	)
}
